import React from "react";
import { Drawer } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { DRAWER_TYPES } from "Constantes/drawers";
import { setActiveDrawer } from "../../Slices/uiSlice";
import { Menu } from "../Menu/Menu";
import "./MenuDrawer.scss";

/**
* Componente de cajón lateral que contiene el menú principal de la aplicación.
* Utiliza Material-UI Drawer y se controla mediante Redux para mostrar/ocultar.
* @returns {JSX.Element} Componente MenuDrawer renderizado
*/
export const MenuDrawer = () => {
  const dispatch = useDispatch();
  const activeDrawer = useSelector((state) => state.ui.activeDrawer);
  const open = activeDrawer === DRAWER_TYPES.MENU;

  const onClose = () => {
    dispatch(setActiveDrawer(null));
  };

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      hideBackdrop
      className="menu-drawer"
    >
      <Menu onClose={onClose} />
    </Drawer>
  );
};
